export default __webpack_public_path__ + "static/media/airstrapz-cbb-2.432a8994.png";